<template>
  <div class="mt-0 elegant-container">
    <v-layout wrap>
      <v-flex>
        <section>
          <div class="customer-page">
    <!-- Animated Background -->
            <div class="animated-bg">
              <div class="bg-shape shape-1"></div>
              <div class="bg-shape shape-2"></div>
              <div class="bg-shape shape-3"></div>
            </div>

            <!-- Page Header -->
            <div class="page-header">
              <!-- <v-btn 
                icon 
                class="back-btn"
                to="/customer/data">
                <v-icon color="#222831">mdi-arrow-left</v-icon>
              </v-btn> -->
              <div class="header-content px-2">
                <div class="d-flex">
                  <h1>Tambah Surat Jalan</h1>
                  <div class="header-badge ml-2">
                    <v-icon size="14" color="white">mdi-account-plus</v-icon>
                    <span>Surat Jalan Baru</span>
                  </div>
                </div>
                <p>Lengkapi informasi surat jalan dengan data yang akurat</p>
              </div>
            </div>

            <!-- Filter Section -->
            <v-card-text class="px-5 py-4 elegant-filter-section" style="background: #294f51;">
              <div class="d-flex align-center mb-5">
                <v-avatar size="36" class="mr-3" style="background: white;">
                  <v-icon size="18" color="#294f51">mdi-filter-variant</v-icon>
                </v-avatar>
                <div>
                  <div class="fs-17 font-weight-bold" style="color: white; letter-spacing: -0.3px;">
                    Filter Pencarian
                  </div>
                  <div class="fs-11 mt-0" style="color: white;">
                    Saring data berdasarkan kriteria
                  </div>
                </div>
              </div>
              <v-row class="mt-0">
                <v-col cols="12" md="6" class="py-2" v-if="$store.state.user.category_user_title !== 'Supervisor'">
                  <v-autocomplete
                    v-model="filterDataSupervisor"
                    :items="supervisor"
                    item-text="name"
                    item-value="id"
                    clearable
                    @click:clear="filterDataSupervisor = ''; fetchOrder();"
                    hide-details
                    @change="fetchOrder()"
                    filled
                    rounded
                    dense
                    class="fs-12 little-placeholder elegant-input"
                    color="#3282B8"
                    placeholder="Nama Supervisor"
                    item-color="#3282B8"
                    prepend-inner-icon="mdi-account-tie"
                    style="border-radius: 6px; background: white !important; transition: all 0.3s ease;">
                    <template v-slot:item="data">
                      <v-list-item-content class="fs-12">{{ data.item.name }}</v-list-item-content>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" md="6" class="py-2">
                  <v-autocomplete
                    v-model="filterDataSales"
                    :items="sales"
                    item-text="name"
                    item-value="name"
                    clearable
                    @click:clear="filterDataSales = ''; fetchOrder();"
                    hide-details
                    @change="fetchOrder()"
                    filled
                    rounded
                    dense
                    class="fs-12 little-placeholder elegant-input"
                    color="#3282B8"
                    placeholder="Nama Sales"
                    item-color="#3282B8"
                    prepend-inner-icon="mdi-account"
                    style="border-radius: 6px; background: white !important; transition: all 0.3s ease;">
                    <template v-slot:item="data">
                      <v-list-item-content class="fs-12">{{ data.item.name }}</v-list-item-content>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" md="3" class="py-2">
                  <ValidationProvider
                    name="Provinsi" 
                    rules="" 
                    v-slot="{ errors }">
                    <v-autocomplete
                      v-on:keyup.enter="save()"
                      v-on:change="changeProvince()"
                      @click:clear="form.province_name = ''; changeProvince();"
                      clearable
                      filled
                      rounded
                      dense
                    class="fs-12 little-placeholder elegant-input"
                    color="#3282B8"
                    hide-details
                    placeholder="Provinsi"
                    :items="province"
                    item-value="name"
                    item-text="name"
                    item-color="#3282B8"
                    v-model="form.province_name"
                    :error-messages="errors"
                    prepend-inner-icon="mdi-map-marker"
                    style="border-radius: 6px; background: white !important; transition: all 0.3s ease;">
                    </v-autocomplete>
                  </ValidationProvider>
                </v-col>
                <v-col cols="12" md="3" class="py-2">
                  <ValidationProvider
                    name="Kota/ Kabupaten" 
                    rules="" 
                    v-slot="{ errors }">
                    <v-autocomplete
                      v-on:keyup.enter="save()"
                      clearable
                      filled
                      rounded
                      dense
                    class="fs-12 little-placeholder elegant-input"
                    color="#3282B8"
                    hide-details
                    v-on:change="changeCity()"
                    @click:clear="form.city_name = ''; changeCity();"
                    placeholder="Kota/ Kabupaten"
                    :items="city"
                    item-value="name"
                    item-text="name"
                    item-color="#3282B8"
                    v-model="form.city_name"
                    :error-messages="errors"
                    prepend-inner-icon="mdi-city"
                    style="border-radius: 6px; background: white !important; transition: all 0.3s ease;">
                    </v-autocomplete>
                  </ValidationProvider>
                </v-col>
                <v-col cols="12" md="3" class="py-2">
                  <ValidationProvider
                    name="Kecamatan" 
                    rules="" 
                    v-slot="{ errors }">
                    <v-autocomplete
                      v-on:keyup.enter="save()"
                      clearable
                      filled
                      rounded
                      dense
                      class="fs-12 little-placeholder elegant-input"
                      color="#3282B8"
                      hide-details
                      v-on:change="changeSubdistrict()"
                      @click:clear="form.subdistrict_name = ''; changeSubdistrict();"
                      placeholder="Kecamatan"
                      :items="subdistrict"
                      item-value="name"
                      item-text="name"
                      item-color="#3282B8"
                      v-model="form.subdistrict_name"
                      :error-messages="errors"
                      prepend-inner-icon="mdi-map"
                      style="border-radius: 6px; background: white !important; transition: all 0.3s ease;">
                    </v-autocomplete>
                  </ValidationProvider>
                </v-col>
                <v-col cols="12" md="3" class="py-2">
                  <ValidationProvider
                    name="Kelurahan" 
                    rules="" 
                    v-slot="{ errors }">
                    <v-autocomplete
                      v-on:keyup.enter="save()"
                      clearable
                      filled
                      rounded
                      dense
                      class="fs-12 little-placeholder elegant-input"
                      color="#3282B8"
                      hide-details
                      v-on:change="changeVillage()"
                      @click:clear="form.village_name = ''; changeVillage();"
                      placeholder="Kelurahan"
                      :items="village"
                      item-value="name"
                      item-text="name"
                      item-color="#3282B8"
                      v-model="form.village_name"
                      :error-messages="errors"
                      prepend-inner-icon="mdi-map-marker-radius"
                      style="border-radius: 6px; background: white !important; transition: all 0.3s ease;">
                    </v-autocomplete>
                  </ValidationProvider>
                </v-col>
              </v-row>
            </v-card-text>
            <!-- Form Section -->
            <v-divider style="border-color: #E8F4F8;"></v-divider>
            <v-card-text class="px-5 py-4 elegant-form-section">
              <div class="d-flex align-center mb-4">
                <v-avatar size="36" class="mr-3" style="background: linear-gradient(135deg, #3282B8 0%, #5C9EAD 100%);">
                  <v-icon size="18" color="white">mdi-form-select</v-icon>
                </v-avatar>
                <div>
                  <div class="fs-17 font-weight-bold" style="color: #2E5266; letter-spacing: -0.3px;">
                    Informasi Surat Jalan
                  </div>
                  <div class="fs-11 mt-1" style="color: #5C9EAD;">
                    Lengkapi data pengiriman
                  </div>
                </div>
              </div>
              <ValidationObserver 
                ref="form">
                <v-form>
                        <!-- <div
                          class="mb-4">
                          <div 
                            class="body-2 mb-2">
                            Poto Profil
                          </div>
  
                          <uploadfolder v-if="form.image_url === ''"
                            v-model="upload.image">
                            <div 
                              slot="activator">
                              <v-card 
                                flat
                                width="200"
                                height="200"
                                class="d-flex align-center justify-center cursor-pointer"
                                style="border-radius: 15px;
                                      border: 2px solid #EBEBEB; 
                                      border-style: dashed;">
                                <v-avatar v-if="!process.image"
                                  v-ripple
                                  tile 
                                  width="200"
                                  height="200">
                                  <v-icon
                                    size="50"
                                    color="#B9B9B9">
                                    mdi-cloud-upload-outline
                                  </v-icon>
                                </v-avatar>
  
                                <v-progress-circular v-else
                                  indeterminate
                                  color="#3282B8">
                                </v-progress-circular>
                              </v-card>
                            </div>
                          </uploadfolder>
  
                          <v-card v-if="form.image_url !== ''"
                            flat
                            width="200"
                            height="200"
                            class="d-flex align-center justify-center"
                            style="border-radius: 15px;
                                  border: 2px solid #EBEBEB; 
                                  border-style: dashed;">
                            <v-avatar
                              v-ripple
                              tile 
                              size="200"
                              style="border-radius: 15px;">
                              <v-img 
                                contain
                                width="100%"
                                height="100%"
                                alt="Mitra Warung" 
                                :src="form.image_url"
                                class="ma-auto"
                                style="border-radius: 15px;">
                                <template v-slot:placeholder>
                                  <v-row
                                    class="fill-height"
                                    align="center"
                                    justify="center">
                                    <v-progress-circular 
                                      indeterminate 
                                      color="#3282B8">
                                    </v-progress-circular>
                                  </v-row>
                                </template>
                              </v-img>
                            </v-avatar>
  
                            <v-icon 
                              @click="form.image_url = ''"
                              color="red"
                              class="cursor-pointer"
                              style="position: absolute; top: -10px; right: -10px;">
                              mdi-close-circle
                            </v-icon>
                          </v-card>
                        </div> -->

                  <!-- Field Ekspedisi - Always Visible -->
                  <div class="" style="margin-bottom: 20px;">
                    <div class="form-field">
                      <label>
                        <span class="field-icon"><v-icon size="16">mdi-truck-delivery</v-icon></span>
                        Ekspedisi
                      </label>
                      <v-select
                        v-on:keydown.enter.prevent="save()"
                        solo
                        flat
                        dense
                        class="elegant-input"
                        background-color="#f8f9fa"
                        placeholder="Pilih Ekspedisi"
                        v-model="form.is_ekspedisi"
                        :items="[
                          { text: 'Ya', value: 1 },
                          { text: 'Tidak', value: 0 }
                        ]"
                        item-text="text"
                        item-value="value"
                        hide-details="auto">
                      </v-select>
                    </div>
                  </div>

  
                  <template v-if="form.is_ekspedisi == 0 || !form.is_ekspedisi">
                    <div class="form-grid">
                      <ValidationProvider
                        name="Nama Driver" 
                        rules="required" 
                        v-slot="{ errors }">
                        <div class="form-field">
                          <label>
                            <span class="field-icon"><v-icon size="16">mdi-account-circle</v-icon></span>
                            Nama Driver
                            <span class="badge-required">Wajib</span>
                          </label>
                          <v-autocomplete
                            v-on:keydown.enter.prevent="save()"
                            solo
                            flat
                            dense
                            class="elegant-input"
                            background-color="#f8f9fa"
                            placeholder="Pilih Nama Driver"
                            :items="driver"
                            item-value="id"
                            item-text="name"
                            v-model="form.driver_id"
                            :error-messages="errors"
                            hide-details="auto">
                          </v-autocomplete>
                        </div>
                      </ValidationProvider>

                      <ValidationProvider
                        name="Nama Vehicle" 
                        rules="required" 
                        v-slot="{ errors }">
                        <div class="form-field">
                          <label>
                            <span class="field-icon"><v-icon size="16">mdi-truck</v-icon></span>
                            Nama Vehicle
                            <span class="badge-required">Wajib</span>
                          </label>
                          <v-autocomplete
                            v-on:keydown.enter.prevent="save()"
                            solo
                            flat
                            dense
                            class="elegant-input"
                            background-color="#f8f9fa"
                            placeholder="Pilih Nama Vehicle"
                            :items="vehicle"
                            item-value="id"
                            :item-text="item => `${item.name} - ${item.number}`"
                            v-model="form.vehicle_id"
                            :error-messages="errors"
                            hide-details="auto">
                            <template v-slot:selection="{ item }">
                              <div v-if="item">
                                {{ item.name }} - {{ item.number }}
                              </div>
                            </template>
                            <template v-slot:item="{ item }">
                              <v-list-item-content>
                                <v-list-item-title>{{ item.name }} - {{ item.number }}</v-list-item-title>
                              </v-list-item-content>
                            </template>
                          </v-autocomplete>
                        </div>
                      </ValidationProvider>
                    </div>
                  </template>
                  <template v-if="form.is_ekspedisi == 1">
                      <v-col cols="12" class="pt-0 mb-3">
                        <v-card 
                          flat 
                          class="pa-5 mt-4 elegant-ekspedisi-card" 
                          style="background: linear-gradient(135deg, #E8F4F8 0%, #A8D5E2 100%); border-radius: 6px; box-shadow: 0 4px 20px rgba(15, 76, 117, 0.12);">
                          <div class="d-flex align-center mb-4">
                            <v-avatar size="36" style="background: linear-gradient(135deg, #3282B8 0%, #5C9EAD 100%); box-shadow: 0 4px 12px rgba(50, 130, 184, 0.3);" class="mr-3">
                              <v-icon color="white" size="18">mdi-truck-delivery</v-icon>
                            </v-avatar>
                            <div>
                              <div class="fs-17 font-weight-bold" style="color: #2E5266; letter-spacing: -0.3px;">
                                Informasi Ekspedisi
                              </div>
                              <div class="fs-11 mt-1" style="color: #5C9EAD;">
                                Lengkapi data ekspedisi untuk pengiriman
                              </div>
                            </div>
                          </div>
                          <v-row>
                            <v-col cols="12" md="4">
                              <ValidationProvider
                                name="Nama Driver Ekspedisi" 
                                rules="required" 
                                v-slot="{ errors }">
                                <div class="fs-14 font-weight-semibold mb-3" style="color: #2E5266; letter-spacing: -0.2px;">
                                  <span class="red--text">*</span>
                                  Nama Driver Ekspedisi
                                </div>
                                <v-text-field
                                  v-on:keydown.enter.prevent="save()"
                                  filled
                                  rounded
                                  dense
                                  solo
                                  color="#3282B8"
                                  placeholder="Masukkan Nama Driver"
                                  v-model="form.ekspedisi_driver_name"
                                  :error-messages="errors"
                                  required
                                  prepend-inner-icon="mdi-account"
                                  style="border-radius: 6px; background: transparent !important; transition: all 0.3s ease;"
                                  class="elegant-input">
                                </v-text-field>
                              </ValidationProvider>
                            </v-col>
                            <v-col cols="12" md="4">
                              <ValidationProvider
                                name="Nama Kendaraan Ekspedisi" 
                                rules="required" 
                                v-slot="{ errors }">
                                <div class="fs-14 font-weight-semibold mb-3" style="color: #2E5266; letter-spacing: -0.2px;">
                                  <span class="red--text">*</span>
                                  Nama Kendaraan Ekspedisi
                                </div>
                                <v-text-field
                                  v-on:keydown.enter.prevent="save()"
                                  filled
                                  rounded
                                  dense
                                  solo
                                  color="#3282B8"
                                  placeholder="Masukkan Nama Kendaraan"
                                  v-model="form.ekspedisi_vehicle_name"
                                  :error-messages="errors"
                                  required
                                  prepend-inner-icon="mdi-truck"
                                  style="border-radius: 6px; background: transparent !important; transition: all 0.3s ease;"
                                  class="elegant-input">
                                </v-text-field>
                              </ValidationProvider>
                            </v-col>
                            <v-col cols="12" md="4">
                              <ValidationProvider
                                name="Nomor Polisi Kendaraan" 
                                rules="required" 
                                v-slot="{ errors }">
                                <div class="fs-14 font-weight-semibold mb-3" style="color: #2E5266; letter-spacing: -0.2px;">
                                  <span class="red--text">*</span>
                                  Nomor Polisi Kendaraan
                                </div>
                                <v-text-field
                                  v-on:keydown.enter.prevent="save()"
                                  filled
                                  rounded
                                  dense
                                  solo
                                  color="#3282B8"
                                  placeholder="Masukkan Nomor Polisi"
                                  v-model="form.ekspedisi_vehicle_number"
                                  :error-messages="errors"
                                  required
                                  prepend-inner-icon="mdi-numeric"
                                  style="border-radius: 6px; background: transparent !important; transition: all 0.3s ease;"
                                  class="elegant-input">
                                </v-text-field>
                              </ValidationProvider>
                            </v-col>
                          </v-row>
                        </v-card>
                      </v-col>
                    </template> 



                    
                    <div class="form-field full-width mt-4">
                      <ValidationProvider 
                        name="Tanggal Kirim" 
                        rules="required" 
                        v-slot="{ errors }">
                        <div class="form-field mb-1">
                          <label>
                            <span class="field-icon"><v-icon size="16">mdi-calendar</v-icon></span>
                            Tanggal Kirim
                            <span class="badge-required">Wajib</span>
                          </label>
                          <v-menu
                            v-model="menu2"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="auto">
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                v-model="form.date"
                                v-on:keyup.enter="save()"
                                solo
                                flat
                                dense
                                class="elegant-input"
                                background-color="#f8f9fa"
                                placeholder="Pilih Tanggal Kirim"
                                :disabled="Object.keys(form).length < 1"
                                :error-messages="errors"
                                readonly
                                hide-details="auto"
                                v-bind="attrs"
                                v-on="on">
                              </v-text-field>
                            </template>
                            <v-date-picker
                              v-model="form.date"
                              :min="new Date().toISOString().substr(0, 10)"
                              @input="menu2 = false">
                            </v-date-picker>
                          </v-menu>
                        </div>
                      </ValidationProvider>
                      <label class="mt-4">
                        <span class="field-icon"><v-icon size="16">mdi-note-text</v-icon></span>
                        Catatan
                      </label>
                      <v-textarea
                        v-on:keydown.enter.prevent="save()"
                        solo
                        flat
                        dense
                        class="elegant-input"
                        background-color="#f8f9fa"
                        placeholder="Masukkan catatan (opsional)"
                        rows="3"
                        v-model="form.note"
                        hide-details="auto">
                      </v-textarea>
                    </div>

                    <v-col cols="12" class="pt-6">
                      <v-divider class="mb-5" style="border-color: #E8F4F8;"></v-divider>
                      <div class="d-flex align-center mb-5">
                        <v-avatar size="36" class="mr-3" style="background: linear-gradient(135deg, #3282B8 0%, #5C9EAD 100%);">
                          <v-icon size="18" color="white">mdi-format-list-bulleted</v-icon>
                        </v-avatar>
                        <div class="flex-grow-1">
                          <div class="fs-17 font-weight-bold" style="color: #2E5266; letter-spacing: -0.3px;">
                            Pilih No BPB
                          </div>
                          <div class="fs-11 mt-1" style="color: #5C9EAD;">
                            Pilih BPB yang akan dikirim
                          </div>
                        </div>
                        <v-chip 
                          v-if="form.bpb_arr.length > 0"
                          small
                          color="#3282B8"
                          text-color="white"
                          class="ml-3"
                          style="box-shadow: 0 2px 8px rgba(50, 130, 184, 0.3); font-weight: 600;">
                          {{ form.bpb_arr.length }} Dipilih
                        </v-chip>
                      </div>

                      <v-card 
                        v-if="!process.load"
                        flat
                        class="elegant-table-card"
                        style="border-radius: 6px; overflow: visible; border: 1px solid #E8F4F8; box-shadow: 0 4px 20px rgba(15, 76, 117, 0.08);">
                        <div class="table-scroll-wrapper">
                          <table class="bpb-table">
                            <thead>
                              <tr>
                                <th class="text-center sticky-col-add-sj" style="width: 60px; min-width: 60px; max-width: 60px;">
                                  <v-icon size="16" color="white">mdi-checkbox-marked</v-icon>
                                </th>
                                <th style="width: 150px; min-width: 150px; white-space: nowrap;">No BPB</th>
                                <th style="width: 180px; min-width: 180px; white-space: nowrap;">No Sales Order</th>
                                <th style="width: 150px; min-width: 150px; white-space: nowrap;">Tgl Order</th>
                                <th style="width: 200px; min-width: 200px;">Nama Toko</th>
                                <th style="width: 300px; min-width: 300px;">Alamat</th>
                                <th style="width: 150px; min-width: 150px; white-space: nowrap;">Nama Sales</th>
                                <th style="width: 250px; min-width: 250px;">Item Order</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr 
                                v-for="(item, index) in order" 
                                :key="index"
                                :class="{ 'selected-row': form.bpb_arr.includes(item.id) }">
                                <td class="text-center sticky-col-add-sj">
                                  <v-checkbox
                                    v-model="form.bpb_arr"
                                    :value="item.id"
                                    color="#3282B8"
                                    hide-details
                                    dense>
                                  </v-checkbox>
                                </td>
                                <td style="width: 150px; min-width: 150px; white-space: nowrap;">
                                  <div class="font-weight-medium" style="color: #3282B8;">
                                    {{ item.number }}
                                  </div>
                                </td>
                                <td style="width: 180px; min-width: 180px; white-space: nowrap;">
                                  <div class="fs-12">{{ item.order_number }}</div>
                                </td>
                                <td style="width: 150px; min-width: 150px; white-space: nowrap;">
                                  <div class="fs-12">{{ item.order_input_datetime | datetime }}</div>
                                </td>
                                <td style="width: 200px; min-width: 200px;">
                                  <div class="font-weight-medium fs-12">{{ item.store_name }}</div>
                                </td>
                                <td style="width: 300px; min-width: 300px;">
                                  <div class="fs-12">
                                    {{ item.customer_shipping_province }}, {{ item.customer_shipping_city }}, {{ item.customer_shipping_subdistrict }}, {{ item.customer_shipping_village }}
                                  </div>
                                </td>
                                <td style="width: 150px; min-width: 150px; white-space: nowrap;">
                                  <v-chip 
                                    small
                                    outlined
                                    color="#3282B8"
                                    class="fs-11">
                                    {{ item.sales_name }}
                                  </v-chip>
                                </td>
                                <td style="width: 250px; min-width: 250px;">
                                  <div v-for="(items, indexs) in item.bpb_detail" :key="indexs" class="fs-11 mb-1">
                                    <v-icon size="12" class="mr-1" color="#5C9EAD">mdi-package-variant</v-icon>
                                    <span class="font-weight-medium">{{ items.bpb_detail_varian_name }}</span>
                                    <span class="ml-1">
                                      <span v-if="items.bpb_detail_qty_pcs*1 > 0" class="fs-11">
                                        {{ items.bpb_detail_qty_pcs }} Pcs
                                      </span>
                                      <span v-if="items.bpb_detail_qty_lusin*1 > 0" class="fs-11">
                                        {{ items.bpb_detail_qty_lusin }} Lusin
                                      </span>
                                      <span v-if="items.bpb_detail_qty_dus*1 > 0" class="fs-11">
                                        {{ items.bpb_detail_qty_dus }} {{ (item.detail[indexs].orders_detail_total_in_dus*1) > 1 ? 'Dus' : 'Pcs' }}
                                      </span>
                                    </span>
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </v-card>

                      <v-card
                        v-if="process.load" 
                        flat
                        class="my-4 elevation-1"
                        style="border-radius: 6px; height: 300px; display: flex; align-items: center; justify-content: center; background: #f8f9fa;">
                        <div class="text-center">
                          <v-progress-circular
                            color="#3282B8"
                            indeterminate
                            size="64"
                            width="6"
                            class="mb-4">
                          </v-progress-circular>
                          <div class="fs-16 font-weight-medium" style="color: #495057;">
                            Memuat Data BPB...
                          </div>
                          <div class="fs-12 mt-2" style="color: #6c757d;">
                            Mohon tunggu sebentar
                          </div>
                        </div>
                      </v-card>

                      <v-card
                        v-if="!process.load && order.length === 0"
                        flat
                        class="my-4 elevation-1"
                        style="border-radius: 6px; height: 300px; display: flex; align-items: center; justify-content: center; background: #f8f9fa;">
                        <div class="text-center">
                          <v-avatar size="100" class="mb-4" style="background: #E8F4F8;">
                            <v-icon size="48" color="#5C9EAD">mdi-inbox-outline</v-icon>
                          </v-avatar>
                          <div class="fs-18 font-weight-medium mt-3" style="color: #495057;">
                            Belum Ada Data BPB
                          </div>
                          <div class="fs-14 mt-2" style="color: #6c757d;">
                            Silakan pilih filter untuk mencari data BPB
                          </div>
                        </div>
                      </v-card>
                    </v-col>

                  <!-- <v-card flat style="border-radius: 25px; border: 1px solid #E7E7E7;" class="mt-6 mb-5">
                    <v-card-text>
                      <div class="fs-18 input-label font-weight-bold py-2">
                        Detail BPB
                      </div>
                    </v-card-text>
                  </v-card>

                  <v-card flat style="border-radius: 25px; border: 1px solid #E7E7E7;" class="pb-7 mt-6 mb-5"  v-for="(items, indexs) in varian_arr" :key="indexs">
                      <v-card-text>
                        <div class="fs-18 input-label mb-8 font-weight-bold pt-2">
                          No. BPB: {{ items[0].bpb_number }}
                        </div>
                        <table width="100%" style="border: thin solid #E6EFF5;">
                          <thead>
                            <tr>
                              <th class="text-left fs-14 font-weight-bold pa-2" style="border-top: thin solid #E6EFF5; border-right: thin solid #E6EFF5;  border-bottom: thin solid #E6EFF5">Nama Barang</th>
                              <th class="text-left fs-14 font-weight-bold pa-2" style="border-top: thin solid #E6EFF5; border-right: thin solid #E6EFF5; border-bottom: thin solid #E6EFF5">No. SKU</th>
                              <th class="text-left fs-14 font-weight-bold pa-2" style="border-top: thin solid #E6EFF5; border-bottom: thin solid #E6EFF5">Qty yang akan dikirim</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(item, index) in items" :key="index">
                              <td class="text-left label-input fs-14 pa-2" style="border-top: thin solid #E6EFF5; border-right: thin solid #E6EFF5;  border-bottom: thin solid #E6EFF5">{{ item.varian_name }}</td>
                              <td class="text-left label-input fs-14 pa-2" style="border-top: thin solid #E6EFF5; border-right: thin solid #E6EFF5;  border-bottom: thin solid #E6EFF5">{{ item.varian_sku }}</td>
                              <td class="text-left label-input fs-14 pa-2" style="border-top: thin solid #E6EFF5; border-right: thin solid #E6EFF5;  border-bottom: thin solid #E6EFF5">
                                <div v-if="item.qty_pcs*1 > 0">
                                  {{ item.qty_pcs }} Pcs
                                </div>
                                <div v-if="item.qty_lusin*1 > 0">
                                  {{ item.qty_lusin }} Lusin
                                </div>
                                <div v-if="item.qty_dus*1 > 0">
                                  {{ item.qty_dus }} Dus
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>

                    </v-card-text>
                  </v-card> -->
                </v-form>
              </ValidationObserver>



              <v-alert
                v-if="message.error.length > 0"
                type="error"
                border="left"
                colored-border
                elevation="2"
                class="my-4"
                style="border-radius: 6px;">
                <div class="d-flex align-center">
                  <v-icon class="mr-2">mdi-alert-circle</v-icon>
                  <span>{{ message.error }}</span>
                </div>
              </v-alert>
            </v-card-text>
  
            <!-- Action Buttons -->
            <v-divider style="border-color: #E8F4F8;"></v-divider>
            <v-card-actions class="px-6 py-6 elegant-action-buttons" style="background: #ffffff;">
              <v-spacer></v-spacer>
              <div class="d-flex align-center">
                <v-btn
                  to="/delivery/surat-jalan"
                  :disabled="process.form"
                  depressed
                  large
                  class="mr-3 elegant-btn-cancel"
                  style="min-width: 130px; height: 44px; border-radius: 10px; text-transform: none; font-weight: 500; letter-spacing: 0.2px; background: #f5f7fa; color: #5C9EAD;">
                  <v-icon left size="16" class="mr-1">mdi-arrow-left</v-icon>
                  Kembali
                </v-btn>
                <v-btn 
                  @click="save()"
                  :loading="process.form"
                  :disabled="process.form"
                  depressed
                  large
                  class="elegant-btn-save"
                  style="min-width: 160px; height: 44px; border-radius: 10px; text-transform: none; font-weight: 600; letter-spacing: 0.3px; background: linear-gradient(135deg, #3282B8 0%, #0F4C75 100%); color: white; box-shadow: 0 3px 12px rgba(50, 130, 184, 0.25);">
                  <v-icon left size="18" class="mr-1">mdi-check</v-icon>
                  Simpan Data
                </v-btn>
              </div>
            </v-card-actions>
          <!-- </v-card>  -->
        </div>
          
          
        </section>
      </v-flex>
    </v-layout>

    <!-- Floating AI Help Button -->
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          fab
          fixed
          bottom
          right
          color="#3282B8"
          elevation="8"
          v-bind="attrs"
          v-on="on"
          @click="$router.push('/delivery/surat-jalan/add-ai')"
          class="white--text elegant-ai-button"
          style="bottom: 24px; right: 24px; width: 56px; height: 56px;">
          <v-icon size="28">mdi-robot</v-icon>
        </v-btn>
      </template>
      <span style="font-weight: 600;">Bantuan AI</span>
    </v-tooltip>
  </div>
</template>

<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {
        date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        menu: {
          
        },
        category: [
          {
            title: 'Parsial',
            id: 'Parsial'
          },
          {
            title: 'Full',
            id: 'Full'
          }
        ],
        modal: false,
        menu2: false,

        dialog: {
          customer: false,
          fullscreen: false
        },
        filterDataSupervisor: '',
        filterDataSales: '',
        supervisor: [],
        bukti: 'gambar',
        gambar_url: '',
        pdf_url: '',
        category: ['Gambar', 'Pdf'],
        pembelian: [],
        product_id: '',
        selected: [],
        headers: [],
        list: [],
        supplier: [],
        form: {
          date: '',
          driver_id: '',
          note: '',
          vehicle_id: '',
          province_name: '',
          city_name: '',
          subdistrict_name: '',
          village_name: '',
          // order_id: '',
          bpb_arr: [],
          varian_arr: [],
          is_ekspedisi: 0,
          ekspedisi_driver_name: '',
          ekspedisi_vehicle_name: '',
          ekspedisi_vehicle_number: '',
          // category: '',
          // image_url: '',
          // pdf_url: ''
        },
        varian_arr: [],
        vehicle: [],
        driver: [],
        order: [],
        headers_data: [],
        supervisor: [],
        branch: [],
        province: [],
        city: [],
        subdistrict: [],
        village: [],
        salesAll: [],
        sales: [],

        mobilephone: {
          name: '',
          id: ''
        },

        lastIndex: 1,

        upload: {
          pdf_url: null,
          image_url: null
        },

        process: {
          form: false,

          pdf_url: false,

          image_url: false,
          load: false
        },
        
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      uploadfolder: () => import(/* webpackPrefetchCategory: true */ '@/components/upload/folder.vue'),
      uploaddocument: () => import(/* webpackPrefetchCategory: true */ '@/components/upload/document.vue')
    },
    watch: {
      'upload.pdf_url': {
        handler: function () {
          if (this.upload.pdf_url) {
            this.process.pdf_url = this.upload.pdf_url.process

            if (!this.process.pdf_url) {
              // CALLBACK FROM UPLOAD IMAGE
              
              this.pdf_url = this.upload.pdf_url.fileuri

              // this.save_image()
            }
          }
        },
        deep: true
      },

      'upload.image_url': {
        handler: function () {
          if (this.upload.image_url) {
            this.process.image_url = this.upload.image_url.process

            if (!this.process.image_url) {
              // CALLBACK FROM UPLOAD IMAGE
              
              this.gambar_url = this.upload.image_url.fileuri

              // this.save_image()
            }
          }
        },
        deep: true
      }
    },
    computed: {
      user () {
        return this.$store.state.user
      },
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      },
      configHeaders () {
          return this.headers_data.filter(header => !header.hide)  
        },
    },
    mounted () {
      this.fetchSupervisor()
      this.fetchSales()
      this.fetchVehicle()
      this.fetchOrder()
      this.fetchDriver()
      this.fetchProv()
    },
    methods: {
      async fetchSales () {
        this.process.load = true

        let params = {
          'category_user_id[eq]': '8',
          limit: 1000000,
          is_active: 'Aktif',
          spv_id: this.$store.state.user.category_user_title === 'Supervisor' ? this.$store.state.user.id : '',
          // limit: 1000000,
          // par_id: '1'
        }

        await get(`admin/user/data`, { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.sales = res.results.data
            this.salesAll = res.results.data
            if(this.filterDataSupervisor !== '' && this.filterDataSupervisor !== null && this.filterDataSupervisor !== undefined) {
              this.sales = this.salesAll.filter(sales => sales.spv_id === this.filterDataSupervisor)
            }
          }
          this.process.load = false
        })
      },
      async fetchSupervisor () {
        // this.process.load = true

        let params = {
          'category_user_id[eq]': '5',
          limit: 1000000,
          is_active: 'Aktif',
          // limit: 1000000,
          // par_id: '1'
        }

        await get(`admin/user/data`, { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.supervisor = res.results.data
            
          }
          // this.process.load = false
        })
      },
      async fetchProv() {

         let params = {
          limit: 10000000000000
        }

        await get(`ref/provinsi`, { params })
        .then(response => {
          let res = response.data
          
          if (res.status === 200) {
            this.province = res.results.data
          }
        })
      },

      changeProvince() {
        this.form.city_name = ''
        this.form.subdistrict_name = ''
        this.form.village_name = ''
        let id = ''
        this.province.map(obj => {
          if (obj.name === this.form.province_name) {
            id = obj.id
          }
        })
        this.fetchOrder()
        this.fetchCity(id)
      },

      async fetchCity(id) {

         let params = {
          limit: 10000000000000,
          province_id: id
        }

        await get(`ref/kota`, { params })
        .then(response => {
          let res = response.data
          
          if (res.status === 200) {
            this.city = res.results.data
          }
        })
      },
      changeCity() {
        this.form.subdistrict_name = ''
        this.form.village_name = ''
        let id = ''
        this.city.map(obj => {
          if (obj.name === this.form.city_name) {
            id = obj.id
          }
        })
        this.fetchOrder()
        this.fetchSub(id)
      },
      // changeCity() {
      //   this.form.subdistrict_name = ''
      //   let id = ''
      //   this.city.map(obj => {
      //     if (obj.name === this.form.city_name) {
      //       id = obj.id
      //     }
      //   })
      //   this.fetchSub(id)
      // },

      async fetchSub(id) {

         let params = {
          limit: 10000000000000,
          city_id: id
        }

        await get(`ref/kecamatan`, { params })
        .then(response => {
          let res = response.data
          
          if (res.status === 200) {
            this.subdistrict = res.results.data
          }
        })
      },

      changeSubdistrict() {
        this.form.village_name = ''
        let id = ''
        this.subdistrict.map(obj => {
          if (obj.name === this.form.subdistrict_name) {
            id = obj.id
          }
        })
        this.fetchOrder()
        this.fetchVil(id)
      },

      async fetchVil(id) {

         let params = {
          limit: 10000000000000,
          subdistrict_id: id
        }

        await get(`ref/kelurahan`, { params })
        .then(response => {
          let res = response.data
          
          if (res.status === 200) {
            this.village = res.results.data
          }
        })
      },
      changeVillage() {
        this.fetchOrder()
      },
      async fetchOrder () {
        this.form.bpb_arr = []
        this.process.load = true

        let params = {
          limit: 1000000,
          is_delivery: '0',
          customer_shipping_province: this.form.province_name,
          customer_shipping_city: this.form.city_name,
          customer_shipping_subdistrict: this.form.subdistrict_name,
          customer_shipping_village: this.form.village_name,
          spv_id: this.$store.state.user.category_user_title === 'Supervisor' ? this.$store.state.user.id : this.filterDataSupervisor,
          sales_name: this.filterDataSales
          // status: 'persiapan'
          // limit: 1000000,
          // par_id: '1'
        }

        await get(`admin/bpb/data`, { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.pembelian = res.results.data
            this.order = res.results.data
            
          }
          this.process.load = false
        })
      },
      async fetchVehicle () {
        // this.process.load = true

        let params = {
          limit: 10000000,
          // limit: 1000000,
          // par_id: '1'
        }

        await get(`admin/vehicle/data`, { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.vehicle = res.results.data
            
          }
          // this.process.load = false
        })
      },
      async fetchDriver () {
        // this.process.load = true

        let params = {
          limit: 10000000,
          'category_user_id[eq]': '11',
          is_active: 'Aktif',
          // limit: 1000000,
          // par_id: '1'
        }

        await get(`admin/user/data`, { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.driver = res.results.data
            
          }
          // this.process.load = false
        })
      },

      changeOrder() {
        this.order_json = []
        this.varian_arr = []
        // this.order_json = this.order.find(x => x.id === this.form.order_id)
        // this.fetchDetailOrder(this.form.order_id)
        for (let i = 0; i < this.form.bpb_arr.length; i++) {
          this.fetchDetailOrder(this.form.bpb_arr[i])
        }
      },

      async fetchDetailOrder (id) {
        let params = {
          bpb_id: id
        }

        await get('admin/bpb/detail', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            // let data = []
            // res.results.data.detail.map((item) => {
            //   data.push(item)
            // })
            // this.order_json.res.results.data
            // data.map((item) => {
              this.varian_arr.push(res.results.data.data)
            // })

            // this.varian_arr.varian_arr = []
            // this.varian_arr.map((items, index) => {
            //   this.varian_arr[index].varian_arr = []
            //   this.varian_arr[index].detail.map((item) => {
            //     this.varian_arr[index].varian_arr.push({
            //       varian_id: item.detail_varian_id,
            //       varian_name: item.detail_varian_name,
            //       varian_sku: item.detail_varian_sku,
            //       qty_pcs_approve: item.detail_qty_pcs_approved === undefined ? 0 : item.detail_qty_pcs_approved*1,
            //       qty_lusin_approve: item.detail_qty_lusin_approved === undefined ? 0 : item.detail_qty_lusin_approved*1,
            //       qty_dus_approve: item.detail_qty_dus_approved === undefined ? 0 : item.detail_qty_dus_approved*1,
            //       qty_pcs: 0,
            //       qty_lusin: 0,
            //       qty_dus: 0,
                  
            //     })
            //   })
            // })


          }
        })
      },

      async save () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate(),
              isBpb = this.form.bpb_arr.length > 0

        this.message.error = isBpb ? '' : 'Silahkan pilih Bpb'
        if (isValid && isBpb) {
          let form = {
            date: this.form.date,
            driver_id: this.form.driver_id,
            note: this.form.note,
            vehicle_id: this.form.vehicle_id,
            bpb_arr: JSON.stringify(this.form.bpb_arr),
            is_ekspedisi: this.form.is_ekspedisi || 0,
            ekspedisi_driver_name: this.form.ekspedisi_driver_name || '',
            ekspedisi_vehicle_name: this.form.ekspedisi_vehicle_name || '',
            ekspedisi_vehicle_number: this.form.ekspedisi_vehicle_number || '',
          }
          this.process.form = true

          // SAVE TO REST API
          await post(`admin/surat_jalan/add`, {
            data: form
          })
          .then((response) => {
            let res = response.data

            this.process.form = false

            if (res.status === 200) {

              this.$router.push({ path: '/delivery/surat-jalan' })

            } else {
              this.message.error = res.message
            }
          })
          
        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            if (errors.length > 0) {
              this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
              })
            }
          }, 10)
        }
      }
    }
  }
</script>

<style scoped>
  /* Color Hunt Palette - https://colorhunt.co/palettes/popular */
  /* #222831 - Dark Navy */
  /* #393E46 - Dark Gray */
  /* #00ADB5 - Teal (Primary) */
  /* #EEEEEE - Light Gray */
  /* #EA5455 - Coral Red */
  /* #F07B3F - Orange */
  /* #FFD460 - Yellow */
  
  /* Page Container */
  .customer-page {
    position: relative;
    padding: 18px !important;
    padding-top: 36px !important;
    min-height: 100%;
    /* padding: 12px; */
    background: linear-gradient(180deg, #fcfcfc 0%, #f8fafa 100%);
  }
  
  /* Animated Background */
  .animated-bg {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    pointer-events: none;
    overflow: hidden;
    z-index: 0;
  }
  
  .bg-shape {
    position: absolute;
    border-radius: 50%;
    opacity: 0.6;
    animation: float 20s ease-in-out infinite;
  }
  
  .shape-1 {
    width: 300px;
    height: 300px;
    background: linear-gradient(135deg, #00ADB5 0%, #00ADB5 100%);
    top: -100px;
    right: -50px;
    filter: blur(60px);
    animation-delay: 0s;
  }
  
  .shape-2 {
    width: 200px;
    height: 200px;
    background: linear-gradient(135deg, #FFD460 0%, #F07B3F 100%);
    bottom: 100px;
    left: -50px;
    filter: blur(50px);
    animation-delay: -5s;
  }
  
  .shape-3 {
    width: 150px;
    height: 150px;
    background: linear-gradient(135deg, #EA5455 0%, #EA5455 100%);
    top: 50%;
    right: 20%;
    filter: blur(40px);
    animation-delay: -10s;
  }
  
  @keyframes float {
    0%, 100% { transform: translateY(0) rotate(0deg); }
    25% { transform: translateY(-20px) rotate(5deg); }
    50% { transform: translateY(0) rotate(0deg); }
    75% { transform: translateY(20px) rotate(-5deg); }
  }
  
  /* Page Header */
  .page-header {
    position: relative;
    z-index: 1;
    display: flex;
    align-items: flex-start;
    gap: 16px;
    margin-bottom: 28px;
  }
  
  .back-btn {
    background: white !important;
    box-shadow: 0 2px 12px rgba(34, 40, 49, 0.08) !important;
    border: 1px solid #EEEEEE !important;
  }
  
  .header-badge {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 4px 12px;
    background: linear-gradient(135deg, #00ADB5 0%, #00ADB5 100%);
    border-radius: 20px;
    margin-bottom: 8px;
  }
  
  .header-badge span {
    font-size: 11px;
    font-weight: 600;
    color: white;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }
  
  .header-content h1 {
    font-size: 18px;
    font-weight: 700;
    color: #222831;
    margin: 0 0 4px;
    letter-spacing: -0.5px;
  }
  
  .header-content p {
    font-size: 14px;
    color: #393E46;
    margin: 0;
  }
  
  /* Stepper */
  .stepper-wrapper {
    position: relative;
    z-index: 1;
    background: white;
    border-radius: 12px;
    padding: 18px 22px;
    margin-bottom: 24px;
    box-shadow: 0 2px 20px rgba(34, 40, 49, 0.06);
    border: 1px solid rgba(238, 238, 238, 0.8);
  }
  
  .stepper-line {
    position: absolute;
    top: 40px;
    left: 80px;
    right: 80px;
    height: 3px;
    background: #EEEEEE;
    border-radius: 2px;
  }
  
  .stepper-line-progress {
    height: 100%;
    background: linear-gradient(90deg, #00ADB5 0%, #00ADB5 100%);
    border-radius: 2px;
    transition: width 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  }
  
  .stepper-items {
    display: flex;
    justify-content: space-between;
    position: relative;
  }
  
  .stepper-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    z-index: 1;
  }
  
  .stepper-circle {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background: white;
    border: 3px solid #EEEEEE;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-weight: 700;
    color: #393E46;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  }
  
  .stepper-item.active .stepper-circle {
    background: #00ADB5;
    border-color: #00ADB5;
    color: white;
    transform: scale(1.1);
    box-shadow: 0 4px 20px rgba(0, 173, 181, 0.4);
  }
  
  .stepper-item.completed .stepper-circle {
    background: #00ADB5;
    border-color: #00ADB5;
    color: white;
  }
  
  .stepper-info {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 2px;
  }
  
  .stepper-step {
    font-size: 10px;
    font-weight: 600;
    color: #393E46;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }
  
  .stepper-title {
    font-size: 13px;
    font-weight: 600;
    color: #222831;
  }
  
  .stepper-item.active .stepper-title {
    color: #00ADB5;
  }
  
  /* Main Card */
  .main-card {
    position: relative;
    z-index: 1;
    background: white;
    border-radius: 12px;
    box-shadow: 0 4px 30px rgba(34, 40, 49, 0.08);
    border: 1px solid rgba(238, 238, 238, 0.6);
    overflow: hidden;
  }
  
  /* Form Step */
  .form-step {
    padding: 24px;
  }
  
  .step-header {
    display: flex;
    align-items: center;
    gap: 16px;
    margin-bottom: 32px;
    padding-bottom: 24px;
    border-bottom: 2px solid #f8f9fa;
  }
  
  .step-icon {
    width: 42px;
    height: 42px;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .step-icon.teal {
    background: linear-gradient(135deg, #00ADB5 0%, #00ADB5 100%);
    box-shadow: 0 8px 20px rgba(0, 173, 181, 0.3);
  }
  
  .step-icon.coral {
    background: linear-gradient(135deg, #EA5455 0%, #EA5455 100%);
    box-shadow: 0 8px 20px rgba(234, 84, 85, 0.3);
  }
  
  .step-icon.orange {
    background: linear-gradient(135deg, #F07B3F 0%, #F07B3F 100%);
    box-shadow: 0 8px 20px rgba(240, 123, 63, 0.3);
  }
  
  .step-icon.yellow {
    background: linear-gradient(135deg, #FFD460 0%, #FFD460 100%);
    box-shadow: 0 8px 20px rgba(255, 212, 96, 0.3);
  }
  
  .step-icon.purple {
    background: linear-gradient(135deg, #9c27b0 0%, #7b1fa2 100%);
    box-shadow: 0 8px 20px rgba(156, 39, 176, 0.3);
  }
  
  .step-header h2 {
    font-size: 14px;
    font-weight: 700;
    color: #222831;
    margin: 0 0 4px;
  }
  
  .step-header p {
    font-size: 12px;
    color: #393E46;
    margin: 0;
  }
  
  /* Form Grid */
  .form-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
  }
  
  .form-field.full-width {
    grid-column: span 2;
  }
  
  /* Form Field */
  .form-field label {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 13px;
    font-weight: 600;
    color: #222831;
    margin-bottom: 10px;
  }
  
  .field-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    background: #f8f9fa;
    border-radius: 6px;
  }
  
  .field-icon .v-icon {
    color: #393E46 !important;
  }
  
  .badge-required {
    margin-left: auto;
    font-size: 10px;
    font-weight: 600;
    color: #EA5455;
    background: rgba(234, 84, 85, 0.1);
    padding: 3px 8px;
    border-radius: 4px;
  }
  
  .badge-optional {
    margin-left: auto;
    font-size: 10px;
    font-weight: 600;
    color: #393E46;
    background: #f8f9fa;
    padding: 3px 8px;
    border-radius: 4px;
  }
  
  /* Elegant Input - Modern Styling */
  .elegant-input >>> .v-input__slot {
    border-radius: 6px !important;
    min-height: 44px !important;
    border: 1px solid #e8eaed !important;
    background: #fafbfc !important;
    transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1) !important;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04) !important;
  }
  
  .elegant-input >>> .v-input__slot:hover {
    border-color: #d0d5dd !important;
    background: #fff !important;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.06) !important;
  }
  
  .elegant-input >>> .v-input--is-focused .v-input__slot {
    background: #ffffff !important;
    border-color: #00ADB5 !important;
    box-shadow: 0 0 0 3px rgba(0, 173, 181, 0.12), 0 1px 2px rgba(0, 0, 0, 0.05) !important;
  }
  
  .elegant-input >>> .v-text-field__slot input,
  .elegant-input >>> .v-select__slot input,
  .elegant-input >>> .v-text-field__slot textarea {
    font-size: 13px !important;
    font-weight: 500 !important;
    color: #222831 !important;
    caret-color: #00ADB5 !important;
  }
  
  .elegant-input >>> .v-text-field__slot input::placeholder,
  .elegant-input >>> .v-select__slot input::placeholder,
  .elegant-input >>> .v-text-field__slot textarea::placeholder {
    color: #9ca3af !important;
    font-weight: 400 !important;
  }
  
  .elegant-input >>> .v-input__append-inner,
  .elegant-input >>> .v-input__prepend-inner {
    margin-top: 0 !important;
    align-self: center !important;
  }
  
  .elegant-input >>> .v-input__append-inner .v-icon,
  .elegant-input >>> .v-input__prepend-inner .v-icon {
    color: #9ca3af !important;
    font-size: 18px !important;
  }
  
  .elegant-input >>> .v-input--is-focused .v-input__append-inner .v-icon {
    color: #00ADB5 !important;
  }
  
  .elegant-input >>> .v-text-field__prefix {
    color: #6b7280 !important;
    font-weight: 500 !important;
    font-size: 13px !important;
  }
  
  .elegant-input >>> .v-select__selections {
    font-size: 13px !important;
    font-weight: 500 !important;
    color: #222831 !important;
  }
  
  .elegant-input >>> .v-input--is-disabled .v-input__slot {
    background: #f3f4f6 !important;
    border-color: #e5e7eb !important;
    opacity: 0.7 !important;
  }
  
  /* Error State */
  .elegant-input.error--text >>> .v-input__slot {
    border-color: #EA5455 !important;
    background: #fff !important;
  }
  
  .elegant-input.error--text >>> .v-input--is-focused .v-input__slot {
    box-shadow: 0 0 0 3px rgba(234, 84, 85, 0.12) !important;
  }
  
  /* Input with Button */
  .input-with-btn {
    display: flex;
    gap: 10px;
  }
  
  .input-with-btn .elegant-input {
    flex: 1;
  }
  
  .add-btn {
    width: 40px;
    height: 40px;
    border: none;
    border-radius: 6px;
    background: linear-gradient(135deg, #00ADB5 0%, #009ba3 100%);
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
    box-shadow: 0 2px 4px rgba(0, 173, 181, 0.25);
  }
  
  .add-btn:hover:not(:disabled) {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0, 173, 181, 0.35);
    background: linear-gradient(135deg, #00bdc6 0%, #00ADB5 100%);
  }
  
  .add-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
  
  /* Phone Error */
  .phone-error {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-top: 6px;
    font-size: 12px;
    color: #EA5455;
    font-weight: 500;
  }
  
  /* Tags */
  .tags-container {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: 12px;
  }
  
  .modern-tag {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 6px 10px;
    background: #ffffff;
    border: 1.5px solid #e8eaed;
    border-radius: 6px;
    font-size: 12px;
    color: #222831;
    font-weight: 500;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
    transition: all 0.2s ease;
  }
  
  .modern-tag:hover {
    border-color: #d0d5dd;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.06);
  }
  
  /* Image Gallery for multiple uploads */
  .image-gallery {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    margin-top: 8px;
  }
  
  .gallery-item {
    position: relative;
    width: 100px;
    height: 100px;
    border-radius: 10px;
    overflow: hidden;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }
  
  .gallery-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  
  .gallery-remove {
    position: absolute;
    top: 4px;
    right: 4px;
    width: 24px;
    height: 24px;
    border: none;
    border-radius: 50%;
    background: rgba(234, 84, 85, 0.9);
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
    opacity: 0;
  }
  
  .gallery-item:hover .gallery-remove {
    opacity: 1;
  }
  
  .gallery-remove:hover {
    background: #EA5455;
    transform: scale(1.1);
  }
  
  .gallery-add {
    width: 100px;
    height: 100px;
    border: 2px dashed #d0d5dd;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 4px;
    cursor: pointer;
    transition: all 0.2s ease;
    background: #fafbfc;
  }
  
  .gallery-add:hover {
    border-color: #00ADB5;
    background: rgba(0, 173, 181, 0.05);
  }
  
  .gallery-add span {
    font-size: 11px;
    color: #6b7280;
    font-weight: 500;
  }
  
  .badge-info {
    margin-left: auto;
    font-size: 10px;
    font-weight: 600;
    color: #00ADB5;
    background: rgba(0, 173, 181, 0.1);
    padding: 3px 8px;
    border-radius: 4px;
  }
  
  .modern-tag .v-icon {
    color: #00ADB5 !important;
  }
  
  .tag-remove {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    height: 18px;
    border: none;
    border-radius: 50%;
    background: #EEEEEE;
    cursor: pointer;
    transition: all 0.2s ease;
  }
  
  .tag-remove:hover {
    background: #EA5455;
  }
  
  .tag-remove:hover .v-icon {
    color: white !important;
  }
  
  /* Search Box */
  .search-box {
    position: relative;
  }
  
  .search-box-icon {
    position: absolute;
    left: 16px;
    top: 50%;
    transform: translateY(-50%);
    color: #393E46 !important;
    z-index: 1;
  }
  
  .search-box-input {
    width: 100%;
    height: 44px;
    padding: 0 16px 0 44px;
    background: #fafbfc;
    border: 1.5px solid #e8eaed;
    border-radius: 10px;
    font-size: 13px;
    font-weight: 500;
    color: #222831;
    outline: none;
    transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
  }
  
  .search-box-input:hover {
    border-color: #d0d5dd;
    background: #f5f6f7;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.06);
  }
  
  .search-box-input:focus {
    background: #ffffff;
    border-color: #00ADB5;
    box-shadow: 0 0 0 3px rgba(0, 173, 181, 0.12), 0 1px 2px rgba(0, 0, 0, 0.05);
  }
  
  .search-box-input::placeholder {
    color: #9ca3af;
    font-weight: 400;
  }
  
  /* Map */
  .map-container {
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 4px 20px rgba(34, 40, 49, 0.1);
    border: 2px solid #EEEEEE;
  }
  
  .gmap-view {
    width: 100%;
    height: 280px;
  }
  
  /* Upload Box */
  .upload-box {
    border: 1.5px dashed #d0d5dd;
    border-radius: 10px;
    padding: 24px;
    cursor: pointer;
    transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
    background: #fafbfc;
    min-height: 120px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
  }
  
  .upload-box:hover {
    border-color: #00ADB5;
    border-style: solid;
    background: rgba(0, 173, 181, 0.04);
    box-shadow: 0 0 0 3px rgba(0, 173, 181, 0.08);
  }
  
  .upload-placeholder {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
  }
  
  .upload-icon-circle {
    width: 64px;
    height: 64px;
    border-radius: 50%;
    background: white;
    border: 2px solid #EEEEEE;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .upload-info {
    text-align: center;
  }
  
  .upload-title {
    display: block;
    font-size: 14px;
    font-weight: 600;
    color: #222831;
    margin-bottom: 4px;
  }
  
  .upload-subtitle {
    font-size: 12px;
    color: #393E46;
  }
  
  .upload-loading {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
  }
  
  .upload-loading span {
    font-size: 13px;
    color: #393E46;
  }
  
  .upload-preview {
    position: relative;
    width: 100%;
  }
  
  .upload-overlay {
    position: absolute;
    inset: 0;
    background: linear-gradient(135deg, rgba(0, 173, 181, 0.9) 0%, rgba(0, 173, 181, 0.9) 100%);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 6px;
    opacity: 0;
    transition: opacity 0.3s ease;
    border-radius: 12px;
  }
  
  .upload-overlay span {
    font-size: 12px;
    color: white;
    font-weight: 600;
  }
  
  .upload-box:hover .upload-overlay {
    opacity: 1;
  }
  
  /* Form Navigation */
  .form-nav {
    display: flex;
    align-items: center;
    padding: 0px 32px;
    padding-bottom: 24px !important;
    background: transparent;
  }
  
  .nav-spacer {
    flex: 1;
  }
  
  .btn {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 12px 24px;
    border: none;
    border-radius: 12px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;
  }
  
  .btn-outline {
    background: white;
    color: #222831;
    border: 1px solid #EEEEEE;
  }
  
  .btn-outline:hover {
    background: #f8f9fa;
    border-color: #00ADB5;
    color: #00ADB5;
  }
  
  .btn-primary {
    background: linear-gradient(135deg, #00ADB5 0%, #00ADB5 100%);
    color: white;
    box-shadow: 0 4px 15px rgba(0, 173, 181, 0.3);
  }
  
  .btn-primary:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(0, 173, 181, 0.4);
  }
  
  .btn-success {
    background: linear-gradient(135deg, #00ADB5 0%, #00ADB5 100%);
    color: white;
    box-shadow: 0 4px 15px rgba(0, 173, 181, 0.3);
  }
  
  .btn-success:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(0, 173, 181, 0.4);
  }
  
  .btn-success:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }
  
  /* Error Toast */
  .error-toast {
    position: fixed;
    top: 24px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 14px 20px;
    background: #EA5455;
    border-radius: 12px;
    box-shadow: 0 4px 20px rgba(234, 84, 85, 0.3);
    z-index: 1000;
  }
  
  .error-toast span {
    color: white;
    font-size: 14px;
    font-weight: 500;
  }
  
  .error-toast button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    border: none;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.2);
    cursor: pointer;
    transition: background 0.2s ease;
  }
  
  .error-toast button:hover {
    background: rgba(255, 255, 255, 0.3);
  }
  
  /* Transitions */
  .fade-slide-enter-active {
    transition: all 0.3s ease-out;
  }
  
  .fade-slide-leave-active {
    transition: all 0.2s ease-in;
  }
  
  .fade-slide-enter {
    transform: translateX(30px);
    opacity: 0;
  }
  
  .fade-slide-leave-to {
    transform: translateX(-30px);
    opacity: 0;
  }
  
  /* Responsive */
  @media (max-width: 960px) {
    .stepper-line {
      display: none;
    }
    
    .stepper-items {
      flex-wrap: wrap;
      justify-content: center;
      gap: 12px;
    }
    
    .stepper-info {
      display: none;
    }
    
    .form-grid {
      grid-template-columns: 1fr;
    }
    
    .form-field.full-width {
      grid-column: span 1;
    }
  }
  
  @media (max-width: 600px) {
    .customer-page {
      padding: 16px;
    }
    
    .header-content h1 {
      font-size: 22px;
    }
    
    .form-step {
      padding: 18px;
    }
    
    .step-icon {
      width: 48px;
      height: 48px;
    }
    
    .step-header h2 {
      font-size: 18px;
    }
    
    .form-nav {
      padding: 16px 20px;
      flex-wrap: wrap;
      gap: 12px;
    }
    
    .btn {
      flex: 1;
      justify-content: center;
    }
    
    .bg-shape {
      opacity: 0.3;
    }
  }
  
/* Elegant Container */
.elegant-container {
  background: linear-gradient(to bottom, #f5f7fa 0%, #ffffff 100%);
  min-height: 100vh;
}

/* Elegant Card */
.elegant-card {
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.elegant-card:hover {
  /* box-shadow: 0 12px 40px rgba(15, 76, 117, 0.15) !important; */
  transform: translateY(-2px);
}

/* Elegant Header */
.elegant-header {
  position: relative;
  overflow: hidden;
}

.elegant-header::before {
  content: '';
  position: absolute;
  top: -50%;
  right: -50%;
  width: 200%;
  height: 200%;
  background: radial-gradient(circle, rgba(255, 255, 255, 0.1) 0%, transparent 70%);
  animation: pulse 8s ease-in-out infinite;
}

@keyframes pulse {
  0%, 100% { transform: scale(1); opacity: 0.5; }
  50% { transform: scale(1.1); opacity: 0.8; }
}

.elegant-avatar {
  transition: all 0.3s ease;
}

.elegant-avatar:hover {
  transform: scale(1.1) rotate(5deg);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2) !important;
}

/* Elegant Input */
.elegant-input {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.elegant-input:hover {
  /* box-shadow: 0 4px 16px rgba(15, 76, 117, 0.12) !important; */
  transform: translateY(-2px);
}

.elegant-input:focus-within {
  /* box-shadow: 0 6px 20px rgba(50, 130, 184, 0.2) !important; */
  transform: translateY(-3px);
}

/* Elegant Filter Section */
.elegant-filter-section {
  position: relative;
}

.elegant-form-section {
  position: relative;
  background: white;
}

/* Elegant Ekspedisi Card */
.elegant-ekspedisi-card {
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.elegant-ekspedisi-card:hover {
  /* box-shadow: 0 8px 32px rgba(15, 76, 117, 0.18) !important; */
  transform: translateY(-4px);
}

/* Elegant Table Card */
.elegant-table-card {
  transition: all 0.3s ease;
}


/* Elegant Buttons */
.elegant-btn-save {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
}

.elegant-btn-save::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.15), transparent);
  transition: left 0.6s ease;
}

.elegant-btn-save:hover:not(:disabled)::before {
  left: 100%;
}

.elegant-btn-save:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(50, 130, 184, 0.35) !important;
  background: linear-gradient(135deg, #3a8fc4 0%, #115a7a 100%) !important;
}

.elegant-btn-save:active:not(:disabled) {
  transform: translateY(0px);
  box-shadow: 0 2px 8px rgba(50, 130, 184, 0.3) !important;
}

.elegant-btn-cancel {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
}

.elegant-btn-cancel:hover:not(:disabled) {
  transform: translateY(-1px);
  background-color: #e8f0f5 !important;
  color: #3282B8 !important;
  box-shadow: 0 3px 10px rgba(92, 158, 173, 0.15) !important;
}

.elegant-btn-cancel:active:not(:disabled) {
  transform: translateY(0px);
  background-color: #e0e8ed !important;
}

/* Table Scroll Wrapper */
.table-scroll-wrapper {
  position: relative;
  overflow-x: auto;
  overflow-y: visible;
  -webkit-overflow-scrolling: touch;
  width: 100%;
  max-width: 100%;
  display: block;
}

/* BPB Table */
.bpb-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  min-width: 1440px;
  table-layout: fixed;
}

.bpb-table thead {
  background: linear-gradient(135deg, #0F4C75 0%, #3282B8 100%);
  position: relative;
}

.bpb-table thead::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
}

.bpb-table thead th {
  color: white !important;
  font-size: 13px;
  font-weight: 600;
  padding: 16px 18px;
  text-align: left;
  border: none;
  white-space: nowrap;
  letter-spacing: 0.3px;
}

.bpb-table thead th:first-child {
  border-top-left-radius: 6px;
}

.bpb-table thead th:last-child {
  border-top-right-radius: 6px;
}

/* Sticky Column */
.bpb-table thead th.sticky-col-add-sj {
  position: sticky;
  left: 0;
  z-index: 2;
  background: #0e4d75;
  box-shadow: 2px 0 4px rgba(0, 0, 0, 0.1);
  border-top-left-radius: 6px;
}

.bpb-table tbody td.sticky-col-add-sj {
  position: sticky;
  left: 0;
  z-index: 5;
  background: white;
  min-width: 60px;
  width: 60px;
}

.bpb-table tbody tr:hover td.sticky-col-add-sj {
  background: #f8f9fa;
}

.bpb-table tbody tr.selected-row td.sticky-col-add-sj {
  background: #E8F4F8;
  box-shadow: inset 0 0 0 1px rgba(50, 130, 184, 0.1);
}

.bpb-table tbody tr.selected-row:hover td.sticky-col-add-sj {
  background: #E8F4F8;
}

.bpb-table tbody tr {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  border-bottom: 1px solid #f0f0f0;
}

.bpb-table tbody tr:hover {
  background-color: #f8f9fa;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(15, 76, 117, 0.08);
}

.bpb-table tbody tr.selected-row {
  background: linear-gradient(90deg, #E8F4F8 0%, rgba(232, 244, 248, 0.5) 100%);
  border-left: 4px solid #3282B8;
  box-shadow: inset 0 0 0 1px rgba(50, 130, 184, 0.1);
}

.bpb-table tbody td {
  padding: 16px 18px;
  font-size: 13px;
  color: #424242;
  vertical-align: middle;
  transition: color 0.2s ease;
}

.bpb-table tbody tr:hover td {
  color: #2E5266;
}

.bpb-table tbody tr:last-child {
  border-bottom: none;
}

/* Smooth transitions */
.v-card {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.v-btn {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

/* Custom scrollbar for table wrapper */
.table-scroll-wrapper::-webkit-scrollbar {
  height: 10px;
}

.table-scroll-wrapper::-webkit-scrollbar-track {
  background: #f1f3f5;
  border-radius: 6px;
}

.table-scroll-wrapper::-webkit-scrollbar-thumb {
  background: linear-gradient(135deg, #5C9EAD 0%, #3282B8 100%);
  border-radius: 6px;
  border: 2px solid #f1f3f5;
}

.table-scroll-wrapper::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(135deg, #3282B8 0%, #0F4C75 100%);
}

/* Elegant Action Buttons */
.elegant-action-buttons {
  position: relative;
}

/* Elegant AI Button */
.elegant-ai-button {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 6px 20px rgba(50, 130, 184, 0.3) !important;
}

.elegant-ai-button:hover {
  transform: translateY(-4px) scale(1.05);
  box-shadow: 0 10px 30px rgba(50, 130, 184, 0.4) !important;
}

.elegant-ai-button:active {
  transform: translateY(-2px) scale(1.02);
}

/* Loading and Empty States */
.v-progress-circular {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

/* Responsive adjustments */
@media (max-width: 960px) {
  .elegant-card {
    margin: 8px !important;
    border-radius: 6px !important;
  }
  
  .elegant-header {
    padding: 20px 16px !important;
  }
  
  .elegant-btn-save,
  .elegant-btn-cancel {
    min-width: 100% !important;
    margin-bottom: 12px;
  }
}

/* Custom margin-top for prepend-inner icon */
.v-text-field--enclosed.v-input--dense:not(.v-text-field--solo) .v-input__prepend-inner {
  margin-top: 9px !important;
}
</style>